"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Text: function() {
        return _index.Text;
    },
    renderText_unstable: function() {
        return _index.renderText_unstable;
    },
    textClassNames: function() {
        return _index.textClassNames;
    },
    useTextStyles_unstable: function() {
        return _index.useTextStyles_unstable;
    },
    useText_unstable: function() {
        return _index.useText_unstable;
    }
});
const _index = require("./components/Text/index");
